import { render, staticRenderFns } from "./que-faut-il-pour-creer-un-site-internet.vue?vue&type=template&id=bc43d27e&"
import script from "./que-faut-il-pour-creer-un-site-internet.vue?vue&type=script&lang=js&"
export * from "./que-faut-il-pour-creer-un-site-internet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports